import React from 'react';
import LoadingSpinner from './LoadingSpinner';

export interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Button yükleniyor mu? */
  loading?: boolean;
  /** Yükleme mesajı */
  loadingText?: string;
  /** Button metni */
  children: React.ReactNode;
  /** Loading spinner rengi */
  spinnerColor?: 'primary' | 'secondary' | 'white';
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading = false,
  loadingText,
  children,
  disabled,
  spinnerColor = 'white',
  className = '',
  ...props
}) => {
  const buttonClasses = [
    className,
    loading ? 'btn-loading' : ''
  ].filter(Boolean).join(' ');

  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={buttonClasses}
    >
      {loading && (
        <LoadingSpinner
          size="small"
          color={spinnerColor}
          hideMessage={true}
        />
      )}
      {loading && loadingText ? loadingText : children}
    </button>
  );
};

export default LoadingButton;
